export function useApi() {
  return useNuxtApp().$api
}
